import triggersLogic from './components/triggers-logic';
import slidersInits from './components/sliders-inits';
import magnificSettings from './components/magnific-settings';
import pageTweaks from './components/page-tweaks';
import cookieNotice from './components/cookie-notice';


// Ready function
var ready = function ( fn ) {
    if ( typeof fn !== 'function' ) return;
    if ( document.readyState === 'interactive' || document.readyState === 'complete' ) {return fn();}
    document.addEventListener( 'DOMContentLoaded', fn, false );
};

// Document is ready
ready(function () {
    triggersLogic();
    slidersInits();
    pageTweaks();
    magnificSettings();
    cookieNotice();
});


// WEBPACK FOOTER //
// ./landingpage.js